import React, { useState, useEffect } from "react";

import {
  TextField,
  Alert,
  Tooltip,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  Select as MSelect,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import { Update, Delete } from "@mui/icons-material";
import Select, { components } from "react-select";

import axios from "axios";
import Loader from "../loader/Loader";
import apiUrl from "../api";

const CustomOption = (props) => {
  return (
    <Tooltip
      title="color"
      placement="left"
      PopperProps={{
        style: { zIndex: 10001 },
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -10],
            },
          },
        ],
        sx: {
          "& .MuiTooltip-tooltip": {
            fontSize: "14px",
            backgroundColor: `${props.data.tooltip}`,
            color: ` ${props.data.tooltip}`,
          },
        },
      }}
    >
      <div>
        <components.Option {...props} />
      </div>
    </Tooltip>
  );
};

function formatDate(date) {
  date = new Date(date);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

function formatDateData(date) {
  date = new Date(date);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

const AddReservationForm = (props) => {
  const [actionData, setActionData] = useState({
    reservation_id: props.reservation_id || "",
    property: {
      value: props.property || "",
      label: props.property || "",
    },

    nights: props.nights || 0,
    adults: props.adults || 0,
    kids: props.children || 0,
    checkin: props.checkIn
      ?
      new Date(
        new Date(props.checkIn).setDate(new Date(props.checkIn).getDate() + 1)
      ).toISOString().split("T")[0]
      : "",
    checkout: props.checkOut
      ? new Date(
          new Date(props.checkOut).setDate(new Date(props.checkOut).getDate() + 1)

      ).toISOString().split("T")[0]
      : "",
    staffNotes: props.staffNotes || "",
    firstName: props.firstName || "",
    lastName: props.lastName || "",
    email: props.email || "",
    phone: props.phone || "",
    cribs: props.cribs || 0,
    highChairs: props.highChairs || 0,
    idPassport: props.idPassport || "",
    guestTotal: props.guestTotal || 0,
    channel: props.channel || "",
    channelAmount: props.channelAmount || 0,
    customerNotes: props.customerNotes || "",
    arrivalTime: props.arrivalTime || "",
    arrivalLocation: props.arrivalLocation || "",
    arrivalFlight: props.arrivalFlight || "",
    departureTime: props.departureTime || "",
    departureLocation: props.departureLocation || "",
    departureFlight: props.departureFlight || "",
  });
  const _id = props._id || "";

  const edit = props.edit || false;
  const view = props.view || false;

  const [isLoading, setIsLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [properties, setProperties] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));

  const fetchProperties = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/property/getPropertiesNames`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setProperties(
        response.data.propertiesNames.map((property) => property.name)
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchProperties();
    if (props.reservationId && props.fetchReservation) {
      fetchReservation();
    } else {
      
      setIsLoading(false);
    }
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setActionData({
      ...actionData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    if (!view) {
      e.preventDefault();
      setIsLoading(true);

      const dataToSend = {
        ...actionData,
        reservationId: actionData.reservation_id,
        property: actionData.property.value,
        nights: actionData.nights,
        adults: actionData.adults,
        kids: actionData.kids,
        checkIn: actionData.checkin,
        checkOut: actionData.checkout,
        staffNotes: actionData.staffNotes,
        firstName: actionData.firstName,
        lastName: actionData.lastName,
        email: actionData.email,
        phone: actionData.phone,
      };

      try {
        if (!edit) {
          const response = await axios.post(
            `${apiUrl}/reservation/createReservation`,
            {
              reservationId: dataToSend.reservation_id,
              property: dataToSend.property,
              nights: dataToSend.nights,
              adults: dataToSend.adults,
              kids: dataToSend.kids,
              checkIn: dataToSend.checkin,
              checkOut: dataToSend.checkout,
              staffNotes: dataToSend.staffNotes,
              firstName: dataToSend.firstName,
              lastName: dataToSend.lastName,
              email: dataToSend.email,
              phone: dataToSend.phone,
            },
            {
              headers: {
                Authorization: `Bearer ${user.token}`,
              },
            }
          );
        } else {
          const response = await axios.put(
            `${apiUrl}/reservation/updateReservation/${_id}`,
            {
              reservationId: dataToSend.reservation_id,
              property: dataToSend.property,
              nights: dataToSend.nights,
              adults: dataToSend.adults,
              kids: dataToSend.kids,
              checkIn: dataToSend.checkin,
              checkOut: dataToSend.checkout,
              staffNotes: dataToSend.staffNotes,
              firstName: dataToSend.firstName,
              lastName: dataToSend.lastName,
              email: dataToSend.email,
              phone: dataToSend.phone,
            },
            {
              headers: {
                Authorization: `Bearer ${user.token}`,
              },
            }
          );
        }

        setSuccessMessage(
          !edit
            ? "Η δραστηριότητα δημιουργήθηκε επιτυχώς"
            : "Η δραστηριότητα ενημερώθηκε επιτυχώς"
        );
        setErrorMessage("");
        setIsLoading(false);
      } catch (error) {
        setSuccessMessage("");
        setErrorMessage(
          !edit
            ? "Σφάλμα κατά τη δημιουργία της δραστηριότητας"
            : "Σφάλμα κατά την ενημέρωση της δραστηριότητας"
        );
        setIsLoading(false);
      }
    }
  };

  const fetchReservation = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/reservation/getReservation/${props.reservationId}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      const checkinDate = new Date(response.data.reservation.checkIn);
      const checkoutDate = new Date(response.data.reservation.checkOut);

      const checkInDayAfter = new Date(
        checkinDate.setDate(checkinDate.getDate() + 1)
      )
        .toISOString()
        .split("T")[0];
      const checkOutDayAfter = new Date(
        checkoutDate.setDate(checkoutDate.getDate() + 1)
      )
        .toISOString()
        .split("T")[0];

      setActionData({
        reservation_id: response.data.reservation.reservationId,
        property: {
          value: response.data.reservation.property,
          label: response.data.reservation.property.name,
        },
        nights: response.data.reservation.nights,
        adults: response.data.reservation.adults,
        kids: response.data.reservation.kids,
        checkin: checkInDayAfter,
        checkout: checkOutDayAfter,
        staffNotes: response.data.reservation.staffNotes,
        firstName: response.data.reservation.firstName,
        lastName: response.data.reservation.lastName,
        email: response.data.reservation.email,
        phone: response.data.reservation.phone,
        cribs: response.data.reservation.cribs,
        highChairs: response.data.reservation.highChairs,
        idPassport: response.data.reservation.idPassport,
        guestTotal: response.data.reservation.guestTotal,
        channel: response.data.reservation.channel,
        channelAmount: response.data.reservation.channelAmount,
        customerNotes: response.data.reservation.customerNotes,
        arrivalTime: response.data.reservation.arrivalTime,
        arrivalLocation: response.data.reservation.arrivalLocation,
        arrivalFlight: response.data.reservation.arrivalFlight,
        departureTime: response.data.reservation.departureTime,
        departureLocation: response.data.reservation.departureLocation,
        departureFlight: response.data.reservation.departureFlight,
      });

      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="ticket-form-wrapper">
      {isLoading && (
        <div>
          <Loader />
        </div>
      )}

      {!isLoading && (
        <form className="ticket-form" onSubmit={view ? null : handleSubmit}>
          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="action_option">
                Reservation ID
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="reservation_id"
                value={actionData.reservation_id}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="property">
                Property
              </label>
              <Select
                isDisabled={view}
                options={properties.map((property) => ({
                  value: property,
                  label: property,
                }))}
                value={actionData.property}
                onChange={(selected) => {
                  
                  setActionData({
                    ...actionData,
                    property: selected,
                  });
                }}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="firstName">
                First Name
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="firstName"
                value={actionData.firstName}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-field">
              <label className="form-field-label" htmlFor="lastName">
                Last Name
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="lastName"
                value={actionData.lastName}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="email">
                Email
              </label>
              {view ? (
                <a
                  href={`mailto:${actionData.email}`}
                  className="form-field-link"
                >
                  {actionData.email}
                </a>
              ) : (
                <input
                  disabled={view}
                  className="form-field-input"
                  type="text"
                  name="email"
                  value={actionData.email}
                  onChange={handleInputChange}
                />
              )}
            </div>

            <div className="form-field">
              <label className="form-field-label" htmlFor="phone">
                Phone Number
              </label>
              {view ? (
                <a href={`tel:${actionData.phone}`} className="form-field-link">
                  {actionData.phone}
                </a>
              ) : (
                <input
                  disabled={view}
                  className="form-field-input"
                  type="text"
                  name="phone"
                  value={actionData.phone}
                  onChange={handleInputChange}
                />
              )}
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="staffNotes">
                Staff Notes
              </label>
              <textarea
                disabled={view}
                className="form-field-input"
                type="text"
                name="staffNotes"
                value={actionData.staffNotes}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="Customer Notes">
                Customer Notes
              </label>
              <textarea
                disabled={view}
                className="form-field-input"
                type="text"
                name="customerNotes"
                value={actionData.customerNotes}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="nights">
                Nights
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="number"
                name="nights"
                value={actionData.nights}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="adults">
                Adults
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="number"
                name="adults"
                value={actionData.adults}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-field">
              <label className="form-field-label" htmlFor="kids">
                Kids
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="number"
                name="kids"
                value={actionData.kids}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="cribs">
                Cribs
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="number"
                name="cribs"
                value={actionData.cribs}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-field">
              <label className="form-field-label" htmlFor="highChairs">
                Highchairs
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="number"
                name="highChairs"
                value={actionData.highChairs}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="idPassport">
                Id / Passport
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="idPassport"
                value={actionData.idPassport}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-field">
              <label className="form-field-label" htmlFor="channel">
                Channel
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="channel"
                value={actionData.channel}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="channelAmount">
                Channel Amount
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="number"
                name="channelAmount"
                value={actionData.channelAmount}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-field">
              <label className="form-field-label" htmlFor="guestTotal">
                Guest Total
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="number"
                name="guestTotal"
                value={actionData.guestTotal}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="checkin">
                Checkin
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="date"
                name="checkin"
                value={actionData.checkin}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-field">
              <label className="form-field-label" htmlFor="checkout">
                Checkout
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="date"
                name="checkout"
                value={
                  actionData.checkout
                }
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="arrivalTime">
                Arrival Time
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="arrivalTime"
                value={actionData.arrivalTime}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-field">
              <label className="form-field-label" htmlFor="arrivalLocation">
                Arrival Location
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="arrivalLocation"
                value={actionData.arrivalLocation}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-field">
              <label className="form-field-label" htmlFor="arrivalFlight">
                Arrival Flight
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="arrivalFlight"
                value={actionData.arrivalFlight}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label className="form-field-label" htmlFor="departureTime">
                Departure Time
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="departureTime"
                value={actionData.departureTime}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-field">
              <label className="form-field-label" htmlFor="departureLocation">
                Departure Location
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="departureLocation"
                value={actionData.departureLocation}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-field">
              <label className="form-field-label" htmlFor="departureFlight">
                Departure Flight
              </label>
              <input
                disabled={view}
                className="form-field-input"
                type="text"
                name="departureFlight"
                value={actionData.departureFlight}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div
            className="form-group"
            style={{
              display: view ? "none" : "block",
            }}
          >
            <div className="form-field">
              <button
                className="add-ticket-button__button"
                style={{
                  backgroundColor: props.color || "var(--primary-color)",
                  color: props.textColor || "var(--primary-text-color)",
                  fontSize: props.fontSize || "15px",
                  fontWeight: props.fontWeight || "600",
                  width: props.width || "100%",
                }}
                type="submit"
              >
                {edit ? "Ενημέρωση" : "Δημιουργία"}
              </button>
            </div>
          </div>
        </form>
      )}
      {successMessage && <Alert severity="success">{successMessage}</Alert>}
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
    </div>
  );
};

export default AddReservationForm;
